/**
 * Predictive search (D4) — adds live results WITHOUT touching the original
 * expanding-search choreography (header.js owns the 230→360/420px animation).
 * - 220ms debounce on input, min 2 characters
 * - fetches the predictive-search section via the Section Rendering API
 * - keyboard: ArrowUp/Down move through options, Enter follows, Esc closes
 * - closes on outside click and when the field empties
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 220;
  var MIN_CHARS = 2;

  function init(form) {
    if (form.dataset.predictiveInit) return;
    form.dataset.predictiveInit = '1';

    var input = form.querySelector('[data-header-search-input]');
    var dropdown = form.querySelector('[data-search-dropdown]');
    if (!input || !dropdown) return;

    var timer = null;
    var lastTerm = '';
    var activeIndex = -1;

    function close() {
      dropdown.hidden = true;
      dropdown.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function options() {
      return Array.prototype.slice.call(dropdown.querySelectorAll('[data-predictive-option]'));
    }

    function highlight(index) {
      var opts = options();
      if (!opts.length) return;
      activeIndex = (index + opts.length) % opts.length;
      opts.forEach(function (opt, i) {
        opt.classList.toggle('is-active', i === activeIndex);
      });
    }

    function fetchResults(term) {
      var url =
        (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') +
        'search/suggest?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6&section_id=predictive-search';

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          if (input.value.trim() !== term) return; // stale response
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var results = doc.querySelector('[data-predictive-results]');
          if (results && results.innerHTML.trim().length) {
            dropdown.innerHTML = results.innerHTML;
            dropdown.hidden = false;
            input.setAttribute('aria-expanded', 'true');
            activeIndex = -1;
          } else {
            close();
          }
        })
        .catch(function () { close(); });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < MIN_CHARS) {
        lastTerm = '';
        close();
        return;
      }
      timer = setTimeout(function () {
        if (term === lastTerm) return;
        lastTerm = term;
        fetchResults(term);
      }, DEBOUNCE_MS);
    });

    input.addEventListener('keydown', function (e) {
      if (dropdown.hidden) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        highlight(activeIndex + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        highlight(activeIndex - 1);
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        var active = options()[activeIndex];
        if (active) window.location.href = active.getAttribute('href');
      } else if (e.key === 'Escape') {
        close();
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });

    // The header collapse (blur) also ends the session
    input.addEventListener('blur', function () {
      // Delay so option clicks land before the dropdown disappears
      setTimeout(function () {
        if (!form.contains(document.activeElement)) close();
      }, 150);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-header-search]').forEach(init);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
